/**
 * Class constants for the sheet surface.
 *
 * The viewport positions the panel; the panel carries the edge treatment.
 * Keeping both halves of the anchoring decision in one map means a sheet can
 * never end up pushed to the right edge but styled as if it were at the left.
 */

export const sheetStyles = {
  trigger:
    'inline-flex items-center justify-center gap-2 rounded-control border border-border-strong bg-surface-raised px-3 py-2 text-sm font-medium text-content transition-colors hover:bg-surface-sunken disabled:pointer-events-none disabled:opacity-50',

  backdrop:
    'fixed inset-0 z-40 bg-content/40 transition-opacity duration-150 data-[starting-style]:opacity-0 data-[ending-style]:opacity-0',

  viewport: 'fixed inset-0 z-50 flex',

  popup:
    'flex flex-col overflow-y-auto bg-surface-raised shadow-lg transition-transform duration-200 data-[starting-style]:opacity-0 data-[ending-style]:opacity-0',

  header: 'flex flex-col gap-1.5 border-b border-border p-4',

  title: 'text-lg font-semibold text-content',

  description: 'text-sm text-content-muted',

  body: 'flex-1 p-4',

  footer:
    'flex flex-wrap items-center justify-end gap-2 border-t border-border p-4',

  close:
    'inline-flex items-center justify-center rounded-control border border-border-strong bg-surface-raised px-3 py-2 text-sm font-medium text-content transition-colors hover:bg-surface-sunken',
} as const;

/** Viewport alignment that pushes the panel to the requested edge. */
export const sheetViewportBySide = {
  left: 'justify-start',
  right: 'justify-end',
  top: 'items-start',
  bottom: 'items-end',
} as const;

/** Panel sizing and edge treatment, matched one-to-one with the viewport map. */
export const sheetPanelBySide = {
  left: 'h-full w-full max-w-md border-r border-border',
  right: 'ml-auto h-full w-full max-w-md border-l border-border',
  top: 'mb-0 w-full max-h-[85vh] border-b border-border',
  bottom: 'mt-auto w-full max-h-[85vh] border-t border-border',
} as const;